export default __webpack_public_path__ + "static/media/blob_green_1.c2599fa8.svg";